/**
 * Floating debug panel - visible when REACT_APP_DEBUG=true
 * Export CSV, clear log, view count
 */
import React, { useState, useEffect } from 'react';
import { downloadCsv, getEntries, clearEntries, isDebugEnabled, autoExportToBackend } from './debugLogger';

export function DebugPanel() {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('kuroco:open-debug-panel', handler);
    return () => window.removeEventListener('kuroco:open-debug-panel', handler);
  }, []);

  if (!isDebugEnabled()) return null;

  const refreshCount = () => setCount(getEntries().length);

  return (
    <div className="fixed bottom-4 right-4 z-[9999] font-mono text-xs">
      {open && (
        <div className="bg-gray-900 text-white rounded-lg shadow-lg p-3 mb-2 min-w-[180px]">
          <div className="font-semibold mb-2 text-gray-300">Debug Log</div>
          <div className="mb-2 text-gray-400">{count} entries</div>
          <div className="flex flex-col gap-1">
            <button
              type="button"
              onClick={() => { downloadCsv(); refreshCount(); }}
              className="px-3 py-1.5 bg-emerald-600 hover:bg-emerald-500 rounded text-left"
            >
              Export CSV
            </button>
            <button
              type="button"
              onClick={() => { autoExportToBackend(); refreshCount(); }}
              className="px-3 py-1.5 bg-blue-600 hover:bg-blue-500 rounded text-left"
              title="Save to backend debug_output/"
            >
              Export to folder
            </button>
            <button
              type="button"
              onClick={() => { clearEntries(); setCount(0); }}
              className="px-3 py-1.5 bg-gray-600 hover:bg-gray-500 rounded text-left"
            >
              Clear
            </button>
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={() => { setOpen(!open); refreshCount(); }}
        className="w-10 h-10 rounded-full bg-gray-800 text-white shadow-lg hover:bg-gray-700 flex items-center justify-center"
        title="Debug"
      >
        {open ? '×' : '🐛'}
      </button>
    </div>
  );
}
